/* eslint-disable no-restricted-imports */
import * as instanceFactory from 'InstanceFactory';
import { AbstractInstanceItem, Categorized, Creatable, DerivedType, Localizable } from 'InstanceFactory';
import { InstanceFactoryExtension } from './InstanceFactoryExtension';
import { helpUrls } from '@Common/Core/InstanceFactory/HelpUrls';

export const extensions = new InstanceFactoryExtension(instanceFactory as {}, helpUrls);

export function byTypeName(typeName: string): AbstractInstanceItem<any> & Partial<DerivedType & Creatable<any> & Categorized & Localizable<any>> {
    return extensions.byTypeName(typeName);
}

export function someOfTypes<
    T extends AbstractInstanceItem<any>,
    TArg extends T[],
    AllTypes = TArg extends ReadonlyArray<Pick<AbstractInstanceItem<infer TI>, 'isInstanceOfType'>> ? TI : never
>(...args: TArg): (doc: unknown) => doc is AllTypes {
    return (doc: unknown): doc is AllTypes => args.some(s => s.isInstanceOfType(doc as any));
}

export * from 'InstanceFactory';
